var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isVisibleToUser())?_c('div',{staticClass:"block form-card"},[(_vm.block.title)?_c('h2',{staticClass:"title title--h2 block__title"},[_vm._v(" "+_vm._s(_vm.block.title)+" ")]):_vm._e(),(_vm.block.text)?_c('div',{staticClass:"block__text",domProps:{"innerHTML":_vm._s(_vm.block.text)}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }